import { formattedAmount } from "../../../utils/helpers/Functions.helper";

const TaxData = ({
  key,
  item,
  ProductDeatils,
  deliveryDetails,
  vendorDetails,
}) => {
  if (item?.sales_price) {
    return (
      <div id="invoice-POS" key={`t-${key}`} className="printable">
        <center id="top">
          <div className="logo"></div>
          <div className="info">
            <h2>e-Delivery</h2>
          </div>
          <hr />
        </center>
        {deliveryDetails ? (
          <div>
            <h3 style={{ fontWeight: "700" }}>Order by</h3>
            <p className="">{deliveryDetails?.name ?? "N/A"}</p>
            <p className="">{deliveryDetails?.phone_number ?? "N/A"}</p>
            <p className="text-gray700">
              {deliveryDetails?.flat_no ?? "N/A"},{" "}
              {deliveryDetails?.landmark ?? "N/A"},
              {deliveryDetails?.street ?? "N/A"},{" "}
              {deliveryDetails?.pin_code ?? "N/A"}
            </p>
          </div>
        ) : (
          ""
        )}
        <hr />
        {vendorDetails ? (
          <div>
            <h3 style={{ fontWeight: "700" }}>Vendor Details</h3>
            <p>{vendorDetails?.first_name || ""}</p>
          </div>
        ) : (
          ""
        )}
        <hr />
        <div>
          <h3 style={{ fontWeight: "700" }}>Product Details</h3>
          <p>
            <b>Product:</b> {ProductDeatils?.product?.name || ""}
          </p>
          <p>
            <b>Quantity:</b> {ProductDeatils?.quantity || ""}
          </p>
          <p>
            Product Base Price:{" "}
            {formattedAmount(
              parseFloat(
                item?.sales_price?.$numberDecimal || item?.sales_price
              ).toFixed(2)
            )}
          </p>
          <p>
            Total Price:{" "}
            {formattedAmount(
              (+item?.taxData?.grandTotal?.$numberDecimal ||
                +item?.taxData?.grandTotal) * +ProductDeatils?.quantity
            )}
          </p>
        </div>
        <hr />
        <div id="mid">
          <div className="info">
            <h3>Tax Details</h3>
          </div>
        </div>

        <div id="bot">
          <table>
            <thead>
              <tr>
                <th>Tax Name</th>
                <th className="text-right">Rate</th>
                <th className="text-right">Amount</th>
              </tr>
            </thead>
            <tbody>
              {item?.taxData?.standardTax?.map((t, i) => (
                <tr key={i}>
                  <td>{t.name}</td>
                  <td className="text-right">
                    {t?.rate.$numberDecimal || t?.rate}%
                  </td>
                  <td className="text-right">
                    {formattedAmount(
                      t?.taxAmount?.$numberDecimal || t?.taxAmount
                    )}
                  </td>
                </tr>
              ))}

              <tr>
                <td>Line Rebase</td>
                <td></td>
                <td className="text-right">
                  {formattedAmount(
                    item?.taxData?.rebase?.$numberDecimal ||
                      item?.taxData?.rebase
                  )}
                </td>
              </tr>
              <tr>
                <td>Referral Fee</td>
                <td className="text-right">
                  {item?.taxData?.adminEarning?.referralFee?.percentage
                    ?.$numberDecimal ||
                    item?.taxData?.adminEarning?.referralFee?.percentage}
                  %
                </td>
                <td className="text-right">
                  {formattedAmount(
                    item?.taxData?.adminEarning?.referralFee?.amount
                      ?.$numberDecimal ||
                      item?.taxData?.adminEarning?.referralFee?.amount
                  )}
                </td>
              </tr>
              <tr>
                <td>Closing Fee</td>
                <td className="text-right">
                  {item?.taxData?.adminEarning?.closingFeeRate
                    ?.$numberDecimal ||
                    item?.taxData?.adminEarning?.closingFeeRate}
                </td>
                <td className="text-right">
                  {formattedAmount(
                    item?.taxData?.adminEarning?.closingFee?.$numberDecimal ||
                      item?.taxData?.adminEarning?.closingFee
                  )}
                </td>
              </tr>
              <tr>
                <td>Additional Fee</td>
                <td className="text-right">
                  {item?.taxData?.additionalFee?.$numberDecimal ||
                    item?.taxData?.additionalFee}
                </td>
                <td className="text-right">
                  {formattedAmount(
                    item?.taxData?.adminEarning?.additionalFee
                      ?.$numberDecimal ||
                      item?.taxData?.adminEarning?.additionalFee
                  )}
                </td>
              </tr>
              <tr>
                <td>Taxable Amount</td>
                <td></td>
                <td className="text-right">
                  {formattedAmount(
                    item?.taxData?.taxableAmount?.$numberDecimal ||
                      item?.taxData?.taxableAmount
                  )}
                </td>
              </tr>
              <tr>
                <td>VAT Included</td>
                <td className="text-right">
                  {item?.taxData?.vat[0]?.rate?.$numberDecimal ||
                    item?.taxData?.vat[0]?.rate}
                  %
                </td>
                <td className="text-right">
                  {formattedAmount(
                    item?.taxData?.vat[0]?.taxAmount?.$numberDecimal ||
                      item?.taxData?.vat[0]?.taxAmount
                  )}
                </td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <th className="text-right" colSpan={2}>
                  Total Price
                </th>

                <th className="text-right">
                  {formattedAmount(
                    item?.taxData?.grandTotal?.$numberDecimal ||
                      item?.taxData?.grandTotal
                  )}
                </th>
              </tr>
              <tr>
                <th colSpan={2} className="text-right">
                  Quantity
                </th>
                <th className="text-right">
                  {" "}
                  {ProductDeatils?.quantity || ""}{" "}
                </th>
              </tr>
              <tr>
                <th colSpan={2} className="text-right">
                  Net Total
                </th>
                <th className="text-right">
                  {formattedAmount(
                    (+item?.taxData?.grandTotal?.$numberDecimal ||
                      +item?.taxData?.grandTotal) * +ProductDeatils?.quantity
                  )}
                </th>
              </tr>
            </thead>
            {/* <tbody>
          <tr>
                      
               <td className="text-right"> 
               {formattedAmount(
                   item?.taxData?.grandTotal?.$numberDecimal ||
                     item?.taxData?.grandTotal
                 )} 
               </td>
               <td className="text-right">
               {ProductDeatils?.quantity || ""} 
               </td>
               <td className="text-right"> 
                 
                  {formattedAmount(
             parseFloat(
               ProductDeatils?.price?.$numberDecimal || ProductDeatils?.price
             ).toFixed(2)
           )}</td>             
                
              </tr>
              </tbody> */}
          </table>
        </div>
      </div>
    );
  }
};

export default TaxData;
